var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/congrat_program.a4bf4808.png","uri@2x": __webpack_public_path__ + "static/media/congrat_program.aca0fe93.png","uri@3x": __webpack_public_path__ + "static/media/congrat_program.86aa693c.png",
    width: 221,
    height: 220
});